import { render } from "./Sms.vue?vue&type=template&id=1d2f4102&lang=pug"
import script from "./Sms.vue?vue&type=script&lang=js"
export * from "./Sms.vue?vue&type=script&lang=js"

import "./Sms.vue?vue&type=style&index=0&id=1d2f4102&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__